import ScrollAnimated from "./ScrollAnimated";
import frontier from "clients/frontier.png";
import grove from "clients/grove.png";
import f1 from "clients/f1.webp";
import krafton from "clients/krafton.png";
import redrover from "clients/redrover.jpg";
import splashdamage from "clients/splashdamage.png";
import vn from "clients/vn.jpg";

export default function FloatingShape(props: any) {
  return (
    <ScrollAnimated
      className=" absolute z-0 left-[50px] bottom-[150px] w-full h-10 hidden md:block"
      movementSpeed={100}
      start={20}
      goal={-20}
    >
      <div
        style={{
          left: `2%`,
          top: `5%`,
          transform: `rotate(-2deg)`,
          backgroundImage: `url(${frontier})`,
        }}
        className={`absolute client`}
      ></div>
      <div
        style={{
          left: `15%`,
          top: `5%`,
          transform: `rotate(-2deg)`,
          backgroundImage: `url(${grove})`,
        }}
        className={`absolute client`}
      ></div>
      <div
        style={{
          left: `27%`,
          top: `5%`,
          transform: `rotate(5deg)`,
          backgroundImage: `url(${f1})`,
        }}
        className={`absolute client`}
      ></div>
      <div
        style={{
          left: `40%`,
          top: `5%`,
          transform: `rotate(-2deg)`,
          backgroundImage: `url(${krafton})`,
        }}
        className={`absolute client`}
      ></div>
      <div
        style={{
          left: `55%`,
          top: `5%`,
          transform: `rotate(5deg)`,
          backgroundImage: `url(${redrover})`,
        }}
        className={`absolute client`}
      ></div>
      <div
        style={{
          left: `70%`,
          top: `5%`,
          transform: `rotate(0deg)`,
          backgroundImage: `url(${splashdamage})`,
        }}
        className={`absolute client`}
      ></div>
      <div
        style={{
          left: `82%`,
          top: `10%`,
          transform: `rotate(2deg)`,
          backgroundImage: `url(${vn})`,
        }}
        className={`absolute client`}
      ></div>
    </ScrollAnimated>
  );
}
